export default function formatLevelStakes(levelStakes) {
    return (levelStakes > 0 ? `+${levelStakes}` : `${levelStakes}`);
}



// WEBPACK FOOTER //
// ./src/js/napsTable/utils/formatLevelStakes.js